import {Button, MenuItem, Select, styled, Autocomplete} from "@mui/material";

export const NewOrderSelect = styled(Select)(({theme}) => ({
    borderColor: theme.barekam.greenLight,
    width: '100%',
    backgroundColor: 'rgb(255, 255, 255)',
}));

export const SearchFild = styled(Autocomplete)(({theme}) => ({
    borderColor: theme.barekam.greenLight,
    width: '100%',
    backgroundColor: 'rgb(255, 255, 255)',
}));

export const FilterSelect = styled(NewOrderSelect)(() => ({
    '& .MuiInputBase-input': {
        height: '1.5rem'
    }
}));

export const OrderPopupSelect = styled(NewOrderSelect)(() => ({
    width: 'fit-content',
    backgroundColor: 'rgb(255, 255, 255)',
}));

export const BarekamMenuItem = styled(MenuItem)(({theme}) => ({
    backgroundColor: 'rgb(255, 255, 255)',
    '&:hover': {
        backgroundColor: theme.barekam.orderPopup.buttons.select.menuItem.backgroundColorHover
    }
}))

export const SelectedBarekamMenuItem = styled(BarekamMenuItem)(({theme}) => ({
    backgroundColor: theme.barekam.orderPopup.buttons.select.menuItem.backgroundColorSelected,
}))

export const StateMenuItem = styled(MenuItem)(({theme}) => ({
    padding: '1.25rem 0.62rem',
    '&:hover': {
        backgroundColor: theme.barekam.orderPopup.buttons.select.menuItem.backgroundColorHover
    }
}))

export const SelectedStateMenuItem = styled(StateMenuItem)(({theme}) => ({
    backgroundColor: theme.barekam.orderPopup.buttons.select.menuItem.backgroundColorSelected
}))

export const NewRecipientMenuItem = styled(BarekamMenuItem)(({theme}) => ({
    color: theme.barekam.green,
    gap: '0.25rem'
}))

export const AddNewRecipientButtonContainer = styled(Button)(({theme}) => ({
    color: theme.barekam.green
}))